export default __webpack_public_path__ + "static/media/Pic9.ce2c79df.jpg";